var d3 = require("d3-selection");

var ChartComponent = function (plot, defs, moduleOptions, data) {
    var windscreen, sectors, slicesDataTransform;

    function renderSlices() {
        windscreen = plot
            .append("g")
            .attr("class", "pcg-windscreen");

        sectors = windscreen
            .selectAll(".pcg-windscreen__sector.pcg-sector")
            .data(data.items)
            .enter().append("g")
            .attr("class", "pcg-windscreen__sector pcg-sector");

        slicesDataTransform = d3.pie()
            .sort(null)
            .value(data => data.value)
            .startAngle(-1 * moduleOptions.angle)
            .endAngle(moduleOptions.angle);

        var slicesData = slicesDataTransform(data.items);

        var slices = sectors
            .selectAll(".pcg-sector__slice")
            .data((d, i) => [slicesData[i]])
            .enter().append("path")
            .attr("class", "pcg-sector__slice")
            .attr("d", d3.arc()
                .outerRadius(moduleOptions.sliceRadius)
                .innerRadius(0)
            )
            .attr("stroke-width", 4)
            .attr("stroke", "white")
            .attr("fill", arc => arc.data.color);

        setGradient(slices);
    }

    function setGradient(slices) {
        var applyGradient = data.gradientColors
            && data.items.length > 2;

        if (applyGradient) {
            slices.each(function (d) {
                var currSlice = d3.select(this);
                var currIndex = d.index;

                if (currIndex >= data.items.length - 2) {
                    var currColor = data.items[currIndex].color;
                    var prevColor = data.items[currIndex - 1].color;

                    var sliceGradient = defs.append("linearGradient")
                        .attr("id", `linearGradient_slice_${currIndex}`)
                        .attr("x1", 0)
                        .attr("y1", 0)
                        .attr("x2", 1)
                        .attr("y2", 0.1)

                    sliceGradient.append("stop").attr("stop-color", prevColor).attr("offset", 0);
                    sliceGradient.append("stop").attr("stop-color", prevColor).attr("offset", 0.2);
                    sliceGradient.append("stop").attr("stop-color", currColor).attr("offset", 1);

                    currSlice.attr("fill", `url(#${sliceGradient.attr("id")})`);
                }
            });
        }
    }

    function renderText() {
        var titlesData = slicesDataTransform.padAngle(0.025)(data.items);
        var titleAttrs = {
            "font-size": 25,
            "font-weight": "bold",
            "text-anchor": "middle"
        };

        var titlesArcData = titlesData
            .map(d => d3.transformArcText(d,
                plot,
                moduleOptions.sliceRadius - 35,
                d => d.data.title,
                titleAttrs)
            );

        d3.drawTextByPath(sectors, titlesArcData, "pcg-title-arc", titleAttrs);

        var descData = slicesDataTransform.padAngle(0.075)(data.items);
        var descAttrs = {
            "font-size": 10,
            "font-weight": "bold",
            "text-anchor": "middle"
        };

        var descArcData = descData
            .map(d => d3.transformArcText(d,
                plot,
                moduleOptions.sliceRadius - 80,
                d => d.data.description,
                descAttrs
                , 20)
            );

        d3.drawTextByPath(sectors, descArcData, "pcg-desc-arc", descAttrs);

        var hintData = slicesDataTransform.padAngle(0.075)(data.items);
        var hintAttrs = {
            "font-size": 10,
            "font-weight": "bold",
            "text-anchor": "middle"
        };

        var hintArcData = hintData
            .map(d => d3.transformArcText(d,
                plot,
                moduleOptions.sliceRadius - 220,
                d => d.data.hint,
                descAttrs)
            );

        d3.drawTextByPath(sectors, hintArcData, "pcg-hint-arc", hintAttrs);
    }

    function renderSeparators() {
        var separatorsData = slicesDataTransform.padAngle(0.025)(data.items);

        var separators = sectors
            .selectAll(".pcg-sector__separator")
            .data((d, i) => [separatorsData[i]])
            .enter().append("path")
            .attr("class", "pcg-sector__separator")
            .attr("d", d3.arc()
                .outerRadius(moduleOptions.separatorRadius)
                .innerRadius(moduleOptions.separatorRadius)
            )
            .attr("stroke-width", 2)
            .attr("stroke", "white")
            .attr("fill", "none");
    }

    function bindEvents() {
        sectors.each(function (data) {
            var sector = d3.select(this);
            var slice = sector.select('.pcg-sector__slice').node();
            var sliceClone = d3.select(slice.parentNode.insertBefore(slice.cloneNode(true), slice.previousSibling));
            sliceClone
                .attr("class", `${sliceClone.attr("class")}~shadow`)
                .attr("fill", "transparent")
                .attr("cursor", "pointer")
                .attr("stroke-width", 2)
                .attr("stroke", "#d1cece")
                .style("opacity", 0);

            sliceClone
                .on("mouseover", function (d) {
                    var separator = d3.select(sliceClone.node().parentNode).select(".pcg-sector__separator");
                    windscreen.node().appendChild(sliceClone.node());

                    // move to css?
                    sliceClone
                        .transition()
                        .duration(200)
                        .style("opacity", 1);

                    separator
                        .transition()
                        .duration(200)
                        .attr("stroke", "#d1cece");
                })
                .on("mouseout", function (d) {
                    sector.node().appendChild(sliceClone.node());
                    var separator = d3.select(sliceClone.node().parentNode)
                        .select(".pcg-sector__separator");

                    sliceClone.interrupt()
                        .style("opacity", 0);
                    separator.interrupt()
                        .attr("stroke", "white");
                })
                .on("click", function (d) {
                    if (data.link) {
                        window.open(data.link, data.linkTarget || "_self");
                    }
                });
        });
    }

    this.render = function () {
        renderSlices();
        renderText();
        renderSeparators();
        bindEvents();
    }
}

module.exports = ChartComponent;
